"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeyboardManager = void 0;
var KeyCode = require("keycode");
var Topics = require("../Data/Topics");
var InputUtils = require("./InputUtils");
var KeyboardMap_1 = require("./KeyboardMap");
var KeyCodes_1 = require("./KeyCodes");
/**
 * Keyboard manager
 */
var KeyboardManager = /** @class */ (function () {
    function KeyboardManager() {
        this._isActive = false;
        this._isEnabled = true;
        this._maps = new Array();
        window.addEventListener(InputUtils.Events.KEY_DOWN, this.onKeyDown.bind(this), false);
        window.addEventListener(InputUtils.Events.MOUSE_DOWN, this.onMouseDown.bind(this), false);
        window.addEventListener(InputUtils.Events.FOCUS, this.onBrowserFocus.bind(this));
        window.addEventListener(InputUtils.Events.BLUR, this.onBrowserBlur.bind(this));
        PubSub.subscribe(Topics.REGISTER_FOCUSABLE, this.onRegisterFocusable.bind(this));
        PubSub.subscribe(Topics.REGISTER_FOCUSABLES, this.onRegisterFocusable.bind(this));
        PubSub.subscribe(Topics.UNREGISTER_FOCUSABLE, this.onUnregisterFocusable.bind(this));
        PubSub.subscribe(Topics.UNREGISTER_FOCUSABLES, this.onUnregisterFocusable.bind(this));
        PubSub.subscribe(Topics.UNREGISTER_ALL_FOCUSABLES, this.onUnregisterAllFocusables.bind(this));
        PubSub.subscribe(Topics.CLEAR_FOCUS, this.onClearFocus.bind(this));
        PubSub.subscribe(Topics.FORCE_FOCUS, this.onForceFocus.bind(this));
        PubSub.subscribe(Topics.KEYBOARD_FORCE_NEIGHBOURS, this.onForceNeighbours.bind(this));
        PubSub.subscribe(Topics.KEYBOARD_CLEAR_NEIGHBOURS, this.onClearNeighbours.bind(this));
        PubSub.subscribe(Topics.PUSH_KEYBOARD_LAYER, this.pushMapLayer.bind(this));
        PubSub.subscribe(Topics.POP_KEYBOARD_LAYER, this.popMapLayer.bind(this));
        PubSub.subscribe(Topics.SET_KEYBOARD_ENABLED, this.onSetKeyboardEnabled.bind(this));
        PubSub.subscribe(Topics.GET_KEYBOARD_STATUS, this.onGetKeyboardStatus.bind(this));
    }
    /**
     * onKeyDown
     * @param pEvent
     */
    KeyboardManager.prototype.onKeyDown = function (pEvent) {
        if (!this._isEnabled) {
            return;
        }
        if (this._isActive === false) {
            if (this._maps.length > 0) {
                this._isActive = true;
                this._maps[0].isActive = true;
                pEvent.preventDefault();
            }
        }
        else {
            if (KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.UP) || KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.W)) {
                this.onDirectionPressed(KeyboardMap_1.Direction.UP);
                pEvent.preventDefault();
            }
            else if (KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.RIGHT) || KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.D)) {
                this.onDirectionPressed(KeyboardMap_1.Direction.RIGHT);
                pEvent.preventDefault();
            }
            else if (KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.DOWN) || KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.S)) {
                this.onDirectionPressed(KeyboardMap_1.Direction.DOWN);
                pEvent.preventDefault();
            }
            else if (KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.LEFT) || KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.A)) {
                this.onDirectionPressed(KeyboardMap_1.Direction.LEFT);
                pEvent.preventDefault();
            }
            else if (KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.ENTER) || KeyCode.isEventKey(pEvent, KeyCodes_1.KeyCodes.SPACEBAR)) {
                if (this._maps.length > 0) {
                    this._maps[0].activateFocussedNode();
                    pEvent.preventDefault();
                }
            }
        }
    };
    /**
     * onDirectionPressed
     * @param pDirection
     */
    KeyboardManager.prototype.onDirectionPressed = function (pDirection) {
        if (this._maps.length > 0) {
            this._maps[0].step(pDirection);
        }
    };
    /**
     * onMouseDown
     */
    KeyboardManager.prototype.onMouseDown = function () {
        if (this._isActive === true) {
            this._isActive = false;
            if (this._maps.length > 0) {
                this._maps[0].isActive = false;
            }
        }
    };
    /**
     * onBrowserBlur
     */
    KeyboardManager.prototype.onBrowserBlur = function () {
        if (this._isActive && this._maps.length > 0) {
            this._maps[0].isActive = false;
        }
    };
    /**
     * onBrowserFocus
     */
    KeyboardManager.prototype.onBrowserFocus = function () {
        if (this._isActive && this._maps.length > 0) {
            this._maps[0].isActive = true;
        }
    };
    KeyboardManager.prototype.onRegisterFocusable = function (pTopic, pData) {
        if (this._maps.length > 0) {
            this._maps[0].registerFocusable(pData);
        }
    };
    KeyboardManager.prototype.onUnregisterFocusable = function (pTopic, pData) {
        for (var _i = 0, _a = this._maps; _i < _a.length; _i++) {
            var map = _a[_i];
            map.unregisterFocusable(pData);
        }
    };
    KeyboardManager.prototype.onUnregisterAllFocusables = function () {
        for (var i = 0; i < this._maps.length; ++i) {
            this._maps[i].clear();
        }
    };
    KeyboardManager.prototype.onClearFocus = function () {
        if (this._maps.length > 0) {
            this._maps[0].clearFocus();
        }
    };
    KeyboardManager.prototype.onForceFocus = function (pTopic, pData) {
        if (this._isActive && this._maps.length > 0) {
            this._maps[0].setFocus(pData);
        }
    };
    KeyboardManager.prototype.onForceNeighbours = function (pTopic, pData) {
        if (this._maps.length > 0) {
            if (!Array.isArray(pData)) {
                pData = [pData];
            }
            for (var _i = 0, pData_1 = pData; _i < pData_1.length; _i++) {
                var token = pData_1[_i];
                for (var i = 0; i < KeyboardMap_1.Direction.NUM_ELEMENTS; ++i) {
                    if (token.neighbours[i] !== undefined) {
                        this._maps[0].forceNeighbour(token.target, token.neighbours[i], i);
                    }
                }
            }
        }
    };
    KeyboardManager.prototype.onClearNeighbours = function () {
        if (this._maps.length > 0) {
            this._maps[0].clearNeighbours();
        }
    };
    KeyboardManager.prototype.onSetKeyboardEnabled = function (pTopic, pData) {
        this._isEnabled = pData;
    };
    KeyboardManager.prototype.onGetKeyboardStatus = function (pTopic, pData) {
        pData({
            enabled: this._isEnabled,
            active: this._isActive,
            layer: this._maps.length,
            currentFocusable: this._maps.length > 0 ? this._maps[0].currentFocusable : undefined,
        });
    };
    /**
     * Pushs map layer
     */
    KeyboardManager.prototype.pushMapLayer = function () {
        if (this._maps.length > 0) {
            this._maps[0].isActive = false;
        }
        var map = new KeyboardMap_1.KeyboardMap();
        this._maps.unshift(map);
        map.isActive = this._isActive;
    };
    /**
     * Pops map layer
     */
    KeyboardManager.prototype.popMapLayer = function () {
        if (this._maps.length > 0) {
            this._maps[0].isActive = false;
            this._maps[0].clear();
        }
        this._maps.shift();
        if (this._maps.length > 0) {
            this._maps[0].isActive = this._isActive;
        }
    };
    return KeyboardManager;
}());
exports.KeyboardManager = KeyboardManager;
//# sourceMappingURL=KeyboardManager.js.map